import script from "./SystemManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemManagement.vue?vue&type=script&setup=true&lang=js"

import "./SystemManagement.vue?vue&type=style&index=0&id=1e5ab55c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5ab55c"]])

export default __exports__